import React, { type ReactNode } from 'react'

import { DetailsListItem } from '../DetailsListItem/DetailsListItem'

export type DetailsListProps = {
  children: ReactNode
}

export const DetailsList = ({ children }: DetailsListProps) => <div>{children}</div>

DetailsList.Item = DetailsListItem
